<div class="listable-instruments-container">
  <div class="sorting-btns-container">
    <libero-button
      label="{{ 'global.buttons.lowRiskFilterButton' | translate }}"
      btnClasses="btn--icon btn--positive btn--w-250"
      svgIcon="sort-down"
      [iconWidth]="30"
      (click)="applySort(sortDirections.LOW_RISK)"
      data-cy="strategy-investments-sort-low-btn"
      [active]="sortDirection === sortDirections.LOW_RISK"
    ></libero-button>
    <libero-button
      label="{{ 'global.buttons.riskFilterButton' | translate }}"
      btnClasses="btn--icon btn--negative btn--w-250"
      svgIcon="sort"
      [iconWidth]="30"
      (click)="applySort(sortDirections.HIGH_RISK)"
      data-cy="strategy-investments-sort-high-btn"
      [active]="sortDirection === sortDirections.HIGH_RISK"
    ></libero-button>
  </div>

  <div class="filter-btn-container">
    <libero-button
      label="{{ 'global.buttons.filterButton' | translate }}"
      btnClasses="btn--icon"
      svgIcon="chevron-down"
      [svgClass]="filtrationVisible ? {'transform': 'rotate(180deg)'} : {}"
      [iconWidth]="18"
      (click)="toggleFiltration()"
      data-cy="strategy-investments-filter-btn"
    ></libero-button>
  </div>

  @if (filtrationVisible && filtrationForm) {
    <div class="filtrations">
      <libero-instrument-filter-search
        [formName]="filtrationForm.controls['searchString']"
        placeholder="{{ 'strategies.filtrationLabels.searchPlaceholder' | translate }}"
        data-cy="edit-instruments-search"
      ></libero-instrument-filter-search>
      <div class="filter-label">
        {{ 'strategies.filtrationLabels.class' | translate }}
      </div>
      <libero-instrument-filter-checkboxes
        [formName]="filtrationForm.controls['instrumentCategory']"
        [translatePrefix]="'investmentChartCategories.'"
      ></libero-instrument-filter-checkboxes>
      <div class="filter-label">
        {{ 'strategies.filtrationLabels.target' | translate }}
      </div>
      <libero-instrument-filter-checkboxes
        [formName]="filtrationForm.controls['instrumentTarget']"
        [translatePrefix]="'strategies.filtrationValues.target.'"
      ></libero-instrument-filter-checkboxes>
      <div class="filter-label">
        {{ 'strategies.filtrationLabels.region' | translate }}
      </div>
      <libero-instrument-filter-checkboxes
        [formName]="filtrationForm.controls['regionalOrientations']"
      ></libero-instrument-filter-checkboxes>
      <div class="filter-label">
        {{ 'strategies.filtrationLabels.currency' | translate }}
      </div>
      <libero-instrument-filter-checkboxes
        [formName]="filtrationForm.controls['currencyCode']"
      ></libero-instrument-filter-checkboxes>
      <div class="filter-label">
        {{ 'strategies.filtrationLabels.riskScore' | translate }}
      </div>
      <libero-instrument-filter-checkboxes
        [formName]="filtrationForm.controls['riskScore']"
      ></libero-instrument-filter-checkboxes>
      <div class="filter-label">
        {{ 'strategies.filtrationLabels.incomeType' | translate }}
      </div>
      <libero-instrument-filter-checkboxes
        [formName]="filtrationForm.controls['instrumentIncomeType']"
        [translatePrefix]="'strategies.filtrationValues.incomeType.'"
      ></libero-instrument-filter-checkboxes>
      <div class="filter-label">
        {{ 'strategies.filtrationLabels.esg' | translate }}
      </div>
      <libero-instrument-filter-checkboxes
        [formName]="filtrationForm.controls['esg']"
      ></libero-instrument-filter-checkboxes>
      <div
        class="cancel-filtrations"
        (click)="setActiveFilters()"
        (keydown.space)="setActiveFilters()"
        (keydown.enter)="setActiveFilters()"
        tabindex="0"
        >
        {{ 'strategies.markAllFilters' | translate }}
      </div>
      <hr class="divider">
    </div>
  }

  @if (availableInstruments?.length === 0) {
    <div class="no-data-container"  data-cy="no-instruments-found-text">
      {{ 'global.error.noData' | translate }}
    </div>
  } @else if (!filteredInstruments.length) {
    <div class="no-data-container" data-cy="no-instruments-found-text">
      {{ 'global.error.noFilteredInstruments' | translate }}
    </div>
  } @else {
    <div
      class="available-instruments-table"
      [ngClass]="{ 'available-instruments-table--no-padding': hideAddButtons }"
      >
      <div
        class="instruments-heading "
        [ngClass]="{ 'instruments-heading--three-row': hideAddButtons }"
        >
        <div class="instruments-table-width">
          {{ 'strategies.colLabelInstrument' | translate }}
        </div>
        <div class="desktop-header">
          {{ 'strategies.colLabelPerformance' | translate }}
          <div class="desktop-instrument-table-buttons">
            <div class="desktop-button-years"
              (click)="changePerformance(1)"
              [ngClass]="{ 'desktop-button-years--active': selectedPerformance === 1 }"
              (keydown.space)="changePerformance(1)"
              (keydown.enter)="changePerformance(1)"
              tabindex="0"
              >
              {{ 'strategies.colButtonYield1Y' | translate }}
            </div>
            <div
              class="desktop-button-years"
              (click)="changePerformance(3)"
              [ngClass]="{ 'desktop-button-years--active': selectedPerformance === 3 }"
              (keydown.space)="changePerformance(3)"
              (keydown.enter)="changePerformance(3)"
              tabindex="0"
              >
              {{ 'strategies.colButtonYield3Y' | translate }}
            </div>
            <div
              class="desktop-button-years"
              (click)="changePerformance(5)"
              [ngClass]="{ 'desktop-button-years--active': selectedPerformance === 5 }"
              (keydown.space)="changePerformance(5)"
              (keydown.enter)="changePerformance(5)"
              tabindex="0"
              >
              {{ 'strategies.colButtonYield5Y' | translate }}
            </div>
          </div>
        </div>
        <div
          class="desktop-header risk-score-header "
          [ngClass]="{'text-end': !hideAddButtons}"
          >
          {{ 'strategies.colLabelRiskScore' | translate }}
          <libero-tooltip-button class="mx-2" [explainPerson]="'monika_skodova'">
            {{ 'global.tooltips.suggestedRiskProfile' | translate }}
          </libero-tooltip-button>
        </div>
        @if (!hideAddButtons) {
          <div class="text-end">
            {{ 'strategies.colLabelAdd' | translate }}
          </div>
        }
      </div>
      <libero-listable-instruments-table
        [availableInstruments]="filteredInstruments"
        [selectedPerformance]="selectedPerformance"
        [refreshPagination]="refreshPagination"
        [hideAddButtons]="hideAddButtons"
      ></libero-listable-instruments-table>
    </div>
  }
</div>